import {Route, BrowserRouter, Routes,} from "react-router-dom";
import Maintenance from "../Pages/maintenance";
import Home from "../Pages/Home";


const Rotas = () => {
    return(
        
        <BrowserRouter>
            <Routes>
                <Route element = { <Home/> } path="/" exact/>
            </Routes>
        </BrowserRouter>
        
    )
}



export default Rotas;